import { ThunkAction, Action } from '@reduxjs/toolkit';
import siteReducer, { SiteState } from './Site';
import searchReducer, { SearchState } from './Search';
import videoReducer, { VideoState } from './Video';

// The top-level state object
export interface ApplicationState {
    site: SiteState;
    search: SearchState;
    video: VideoState;
}

// Whenever an action is dispatched, Redux will update each top-level application state property using
// the reducer with the matching name. It's important that the names match exactly, and that the reducer
// acts on the corresponding ApplicationState property type.
export const reducers = {
    site: siteReducer,
    search: searchReducer,
    video: videoReducer
};

export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, ApplicationState, unknown, Action<string>>;

// This type can be used as a hint on action creators so that its 'dispatch' and 'getState' params are
// correctly typed to match your store.
export interface AppThunkAction<TAction> {
    (dispatch: (action: TAction) => void, getState: () => ApplicationState): void;
}
